import { Fragment, type ReactNode } from 'react'
import { Button } from '@systemeio/components'

export interface CommentListWithLoaderProps<T extends { id: number; nextId: number | null }> {
  items: T[]
  renderItem: (item: T) => ReactNode
  onLoadMore: () => void
  isLoadingMore: boolean
  loadMoreLabel: string
}

export const CommentListWithLoader = <T extends { id: number; nextId: number | null }>({
  items,
  renderItem,
  onLoadMore,
  isLoadingMore,
  loadMoreLabel,
}: CommentListWithLoaderProps<T>): ReactNode => {
  const firstGapIndex = items.findIndex((item, index) => {
    const nextItem = items[index + 1]
    return item.nextId !== null && (!nextItem || nextItem.id !== item.nextId)
  })

  return (
    <>
      {items.map((item, index) => (
        <Fragment key={item.id}>
          {renderItem(item)}
          {index === firstGapIndex && (
            <Button
              className="w-full"
              isLoading={isLoadingMore}
              onClick={onLoadMore}
              variant="ghost-gray"
            >
              {loadMoreLabel}
            </Button>
          )}
        </Fragment>
      ))}
    </>
  )
}
